import designTokens from '@customink/design-tokens/build/ci_light/js/designTokens';
var themeOptions = function (theme) { return ({
    components: {
        MuiLink: {
            defaultProps: {},
            styleOverrides: {
                root: {
                    fontFamily: theme.typography.fontFamily,
                    cursor: 'pointer',
                    textDecoration: 'none',
                    color: designTokens.color.blue.default.value,
                    '&[disabled]': {
                        color: designTokens.color.gray.limestone.value,
                        opacity: '1',
                        textDecoration: 'none',
                        cursor: 'default',
                        pointerEvents: 'none',
                    },
                    '&:active': {
                        color: designTokens.color.blue.active.value,
                        textDecoration: 'underline',
                    },
                    '&:hover': {
                        color: designTokens.color.blue.hover.value,
                        textDecoration: 'underline',
                    },
                },
            },
        },
    },
}); };
export default themeOptions;
//# sourceMappingURL=linkTheme.js.map